export const GET_ITENS = 'getItens';
export const ADD_ITEM = 'addItem';
export const REMOVE_ITEM = 'removeItem';
export const REMOVE_CARRINHO = 'removeCarrinho';
